/**
 * @generated SignedSource<<2102c751013adb87b04083d2d31e4555>>
 * @relayHash d82ceab955fc558f582faba05877ecf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ThemeQuery$variables = Record<PropertyKey, never>;
export type ThemeQuery$data = {
  readonly lookAndFeel: {
    readonly custom: {
      readonly horizontalHeader: {
        readonly backgroundColor: string | null | undefined;
        readonly primaryNavigation: {
          readonly highlightColor: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ThemeQuery = {
  response: ThemeQuery$data;
  variables: ThemeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "LookAndFeelSettings",
    "kind": "LinkedField",
    "name": "lookAndFeel",
    "plural": false,
    "selections": [
      {
        "concreteType": "LookAndFeel",
        "kind": "LinkedField",
        "name": "custom",
        "plural": false,
        "selections": [
          {
            "concreteType": "HeaderLookAndFeel",
            "kind": "LinkedField",
            "name": "horizontalHeader",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "backgroundColor"
              },
              {
                "concreteType": "NavigationLookAndFeel",
                "kind": "LinkedField",
                "name": "primaryNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "highlightColor"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ThemeQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ThemeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d82ceab955fc558f582faba05877ecf8",
    "id": "765401ffb83f2e2a720c85a5da2a39f56c3a779bc1c3bf8b59c8eef803276a03",
    "metadata": {},
    "name": "ThemeQuery",
    "operationKind": "query",
    "text": "query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor,primaryNavigation{highlightColor}}}}}"
  }
};
})();

(node as any).hash = "1e70f0bab96233984a0d61d455b5303b";

export default node;
